export default {
  login: 'acesso',
  address: 'Endereço *',
  'create-account-247-support': 'Suporte 24 horas',
  'create-account-secure': '100% Seguro',
  'create-account-fast': 'Saques Rápidas e Fáceis',
  'create-account-gambling-commission': 'Autoridade de Jogos de Malta',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Bônus de Boas-vindas',
  'create-account-promotion-description': 'Até ##UPTO_AMOUNT## no seu primeiro depósito',
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## Giros Grátis',
  'create-account-promotion-spins-bonus-gb': '+ ##SPINS_AMOUNT## Giros Bônus',

  'create-account-promotion-terms-row':
    '<a href="/playerprotection">18+.</a> <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Aplicacdm-se os termos.</a>Aposte com responsabilidade. <a href="http://www.gamblingtherapy.org" target="_blank">www.Gamblingtherapy.org</a>',

  'create-account-promotion-terms-gb':
    '<a href="/playerprotection">18+.</a> Apenas Novos Jogadores. 1 oferta bônus por jogador. Depósito mín. de %minDeposit%. A aposta máx. do bônus é %maxBonusBet%. Os giros bônus estão disponíveis apenas nos jogos selecionados e devem ser usados dentro de 72 horas. Os ganhos dos giros grátis creditados como bônus estão limitados a %maxCap%. Os fundos bônus expiram em 30 dias, fundos bônus não usados serão removidos. A Oferta de Boas-vindas é um bônus proporcional de %firstBonus% até %firstUpTo% + %firstSpins% giros grátis no seu 1º depósito, um bônus proporcional de %secondBonus% até %secondUpTo% + %secondSpins% giros grátis no seu 2º depósito, e um bônus proporcional de %thirdBonus% até %thirdUpTo% + %thirdSpins% giros grátis no seu 3º depósito. Fundos Bônus são separados do fundo em Dinheiro e estão sujeitos aos requisitos mínimos de aposta de 35x referente ao total de bônus dinheiro. Apenas fundos bônus contam para os requisitos mínimos de aposta. <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Aplicam-se os termos.</a> Aposte com responsabilidade. <a href="http://www.begambleaware.org/" target="_blank">BeGambleAware.org</a>',

  'create-account-promotion-terms-latam':
    '<a href="/playerprotection">18+.</a> <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Aplicam-se os termos.</a>Aposte com responsabilidade. <a href="http://www.gamblingtherapy.org" target="_blank">www.Gamblingtherapy.org</a>',

  //Sign in btn text
  'create-account-promotion-sign-in': 'Já possui uma conta?',
  'create-account-close': 'fechar',

  // step 1
  'personal-details-title': 'Inscrever-se',
  'personal-details-supporting-text': 'Apenas 3 passos simples',

  // step 2
  'address-details-title': 'Quase lá!',
  'address-details-supporting-text': 'Você está voando!',

  // step 3
  'account-details-title': '%firstname%',
  'account-details-supporting-text': 'Essa é a última etapa!',

  // helpandsupport_contactinfo_h2
  // gi_account_information

  'trustly-personal-details-create-account': 'Continuar',

  'marketing-preferences-title': 'Preferências de Comunicação',
  'marketing-preferences-description':
    'O Ursa Casino oferece à sua Comunidade de Jogadores Promoções Diárias e Destaques do Mês como bônus proporcionais, giros bônus, giros grátis, ofertas de reembolso, torneios, tabelas de classificação, prêmios reais, experiências e feriados. Para mais informações, selecione a opção abaixo:',
  'marketing-preferences-post-text': 'Você pode atualizar suas preferências de comunicação a qualquer momento na seção Minha Conta.',
  'marketing-preferences-label-cross-brand': 'Quero mais informações sobre ofertas exclusivas da sua rede do cassino.',
  'marketing-preferences-label-brand-only': 'Quero mais informações sobre ofertas exclusivas apenas do seu cassino.',
  'marketing-preferences-label-email': 'Quero mais informações sobre ofertas via <strong>e-mail</strong>',
  'marketing-preferences-label-sms': 'Quero mais informações sobre ofertas via <strong>sms</strong>',
  'marketing-preferences-label-phone-call': 'Quero mais informações sobre ofertas via <strong>phone call</strong>',
  'marketing-preferences-label-post': 'Quero mais informações sobre ofertas via <strong>post</strong>',

  'marketing-preferences-unified-description':
    '<strong>Não perca</strong> as últimas promoções e ofertas exclusivas do Ursa Casino e marcas gerenciadas <a href="/brands" target="_blank">pela nossa rede</a>. Escolha como você prefere receber nossas comunicações.',
  'marketing-preferences-unified-label-email': 'E-mail',
  'marketing-preferences-unified-label-sms': 'SMS',
  'marketing-preferences-unified-label-phone-call': 'Telefone',
  'marketing-preferences-unified-label-phone-post': 'Postagens',
  'deposit-custom-footer':
    "<ul><li class='safe-support'>Suporte 24 horas</li><li class='one-hundred-percent-secure'>100% Seguro</li><li class='usp-fast'>Saques Rápidas e Fáceis</li></ul>",
  'trustly-signup': 'Inscreva-se com o trustly',
  'or-signup-option': 'ou',
};
